import { parseOrder } from 'src/utils'

import { CartProductItem } from '../../types'

export const parseOrderList = (orderList: CartProductItem[]) => {
  return orderList.map((item, index) => {
    return parseOrder(item, index)
  })
}
